import ttt from "@xingternal/ticktricktrack";
const hostname = globalThis.location && globalThis.location.hostname || "default";
const envs = {
  localhost: "development",
  "www.xing.com": "production",
  default: "preview"
};
const env = envs[hostname] || envs["default"];
const initTracking = () => {
  ttt.init(env, { fetchTrackingData: true });
  return ttt;
};
export {
  initTracking
};
